import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/google-slides.vue
var s = {
	name: "DtIconGoogleSlides",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["fill"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--google-slides"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Google Slides",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		t[1] || (t[1] = i("path", {
			d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v19A1.5 1.5 0 0 0 5.5 23h13a1.5 1.5 0 0 0 1.5-1.5V7l-6-6H5.5Z",
			fill: "#F4B70A"
		}, null, -1)),
		t[2] || (t[2] = i("path", {
			d: "M5.5 23A1.5 1.5 0 0 1 4 21.5v-.25a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v.25a1.5 1.5 0 0 1-1.5 1.5h-13Z",
			fill: "#EFA904"
		}, null, -1)),
		t[3] || (t[3] = i("path", {
			d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v.25a1.5 1.5 0 0 1 1.5-1.5h8.75L14 1H5.5Z",
			fill: "#F6C028"
		}, null, -1)),
		i("path", {
			d: "M20 12.125V7l-.875-.875h-4.22a.375.375 0 0 0-.265.64l5.36 5.36Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, l),
		t[4] || (t[4] = i("path", {
			d: "m14 1 6 6h-4.5A1.5 1.5 0 0 1 14 5.5V1Z",
			fill: "#FADC87"
		}, null, -1)),
		t[5] || (t[5] = i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M8.5 11a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7Zm6.5 2.25H9v3.5h6v-3.5Z",
			fill: "#fff"
		}, null, -1)),
		i("defs", null, [i("linearGradient", {
			id: `${e.uniqueID}a`,
			x1: "17.265",
			y1: "12.125",
			x2: "17.265",
			y2: "6",
			gradientUnits: "userSpaceOnUse"
		}, [...t[0] || (t[0] = [i("stop", { "stop-color": "#F4B70A" }, null, -1), i("stop", {
			offset: "1",
			"stop-color": "#E2930A"
		}, null, -1)])], 8, u)])
	], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=google-slides.js.map